import { useState, useRef, useEffect } from "react";
import "./App.css";
import useThemeColor from "./hooks/TopBarColorWheel";
import useContainerHeight from "./hooks/useContainerHeight";

export function PaymentPage(props) {
  useThemeColor();
  const containerHeight = useContainerHeight();
  return (
    <div className="App" style={{ height: containerHeight - 48 }}>
      <div
        className="App-header"
        style={{ justifyContent: "center", textAlign: "center" }}
      >
        <p className="text-h1">KJØP FULLFØRT</p>
        <p className="text-h1 top-margin-m">GÅ TILBAKE TIL FANEN DU VAR I</p>
      </div>

      <div className="background"></div>
    </div>
  );
}
